<template>
  <table class="table table-striped hidden-xs">
    <thead>
      <tr>
        <th><small>Name</small></th>
        <th><small>Email</small></th>
        <th></th>
      </tr>
      <tr
        v-for="(subscriber, index) in cart.cartItems[cartItemIndex]
          .testDriveSubscribers"
        :key="index"
      >
        <td>{{ subscriber.first_name }} {{ subscriber.last_name }}</td>
        <td>{{ subscriber.email }}</td>
        <td>
          <a
            href="#"
            class="text=decoration-none"
            @click.stop="
              confirmRemoveTestDrive(subscriber.pivot.testdrive_subscriber_id)
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
              ></path>
            </svg>
          </a>
        </td>
      </tr>
    </thead>
  </table>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
import store from "../../store/stores";

export default {
  name: "CartItemTestDrives",
  store,
  props: {
    cartItemIndex: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState(["cart"]),
  },
  methods: {
    removeTestDrive(
      subscriberId,
      cartId = this.cart.cartItems[this.cartItemIndex].cartId
    ) {
      return this.$store.dispatch("cart/removeTestDrive", {
        subscriberId,
        cartId,
      });
    },
    confirmRemoveTestDrive(event) {
      swal
        .fire({
          title: "Just checking...",
          type: "question",
          html: `
          <div style="font-size: small">
          <p style="margin: auto">Are you sure you would like to remove this Test Drive Subscriber from your cart?</p>
          </div>
        `,
          showCancelButton: true,
          cancelButtonText: "No",
          cancelButtonColor: "rgb(92, 184, 92)",
          confirmButtonText: "Yes",
          confirmButtonColor: "rgb(217, 83, 79)",
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: () => {
            return this.removeTestDrive(event);
          },
        })
        .then(function (response) {
          if (response.value.data) {
            if (response.value.data.error) {
              swal.fire({
                title: "Uh oh..",
                type: "error",
                html: `<p style="font-size: small">We were unable to process your request!</p>
                     <p style="font-size: small">${response.value.data.error}</p>`,
              });
            } else {
              swal.fire({
                title: "Success!",
                type: "success",
                html: `<p style="font-size: small">Test Drive removed successful!!</p>`,
              });
            }
          } else {
            swal.fire({
              type: "error",
              title: "Uh oh!",
              text: "Something went wrong..",
            });
          }
        });
    },
  },
};
</script>

<style scoped></style>
